import React, { Component, useState, useEffect } from "react";
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography, Paper, InputLabel } from "@material-ui/core";
import Footer from "../Landingpagecomponents/Footer/Footer"
import clsx from 'clsx';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  makeStyles
} from '@material-ui/core';

import * as AuthActions from "../store/actions/auth";

import { useDispatch, useSelector } from "react-redux"
import { withRouter, useHistory } from "react-router-dom";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#eaeaea',
    minHeight: '100vh'
  },
  topSpacer: {
    backgroundColor: '#002D55',
    /* use viewport-based heights so spacer scales with screen size */
    height: '15vh',
    padding: '2%',
    marginBottom: '0%'
  },
  form: {
    width: '600px',
    margin: '20px auto',
    padding: 20,
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      width: '60%',
      margin: '20px auto'
    },
    [theme.breakpoints.down('sm')]: {
      width: '92%',
      margin: '20px auto',
      padding: 16
    }
  },
  card: {
    width: '100%',
    borderRadius: 18,
  },
  textField: {
    // target outlined input's border and label on hover/focus
    '& .MuiOutlinedInput-root': {
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#fb741a'
      }
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fb741a'
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#fb741a'
    }
  },
  footerSpacer: {
    height: '1vh',
    marginTop: "1%",
    marginBottom: "1%"
  },
  Button: {
    color: '#FFFFFF',
    backgroundColor: '#002D55',
    borderRadius: 12,
    '&:hover': {
      backgroundColor: '#fb741a'
    }
  }
}));


const verifyId = async _id => {
  const response = await fetch("https://api.virtus-one.com/account/verifyActivationId/", {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({
      eid: _id
    })
  })


  if (response.ok) {
    const data = await response.json()
    if (data.verified) {
      return true
    }

  }
  return false
}

const Verify_user = (props) => {
  const classes = useStyles();
  const [eid, setEid] = useState(null);
  const [hasVerified, setHasVerified] = useState(false);
  const [roleType, setRoleType] = useState(null);
  const [confirmPassword1, setConfirmPassword1] = useState("")
  const [confirmPassword2, setConfirmPassword2] = useState("")
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    const _id = props.match.params.encryptedUserId

    if (_id != undefined) {
      setEid(_id)

      // read optional role_type from query param so we can include it in activation POST
      try {
        const params = new URLSearchParams(props.location.search);
        const rt = params.get('role_type');
        if (rt) setRoleType(rt);
      } catch (e) {
        // ignore if location.search not available
      }

      verifyId(_id).then(verified => {

        if (verified) {
          setHasVerified(true)
        } else {
          window.location.replace("/");
        }

      })
    }

  }, [])

  const handleSetPassword = async () => {
    console.log(1)
    if (confirmPassword1 === confirmPassword2) 
    {
      console.log(confirmPassword1)
      console.log(2)
      setIsLoading(true)
      let action;
      // pass roleType (may be null) so backend receives explicit role choice
      action = AuthActions.verifyAccount(eid, confirmPassword1, roleType);
      try {
        const result = await dispatch(action);
        setIsLoading(false);
        // route based on role returned from backend
        const role = result && result.role ? result.role : null;
        const user = result && result.user ? result.user : null;
        const adminRoles = ['careprovider_admin', 'care_provider', 'clinic_admin', 'admin', 'staff', 'care_staff', 'physiotherapist'];
        if (role && adminRoles.includes(role.role_type)) {
          try {
            localStorage.setItem('vp_activeTab', 'clinicCalendar');
          } catch (e) {
            // ignore
          }
          history.push('/admin_dashboard');
        } else if (user && user.portal_access_requires_first_attendance) {
          history.push('/portal_pending_activation');
        } else {
          history.push('/learn_about_your_pain');
        }
      } catch (err) {
        setIsLoading(false);
        alert(err);
      }
    } else {
      alert("Passwords does not match!") // Show error here
    }
  }

  if (hasVerified) {
    return (
      <Grid container className={classes.root}>
        <Header />
        <Grid item xs={12} className={classes.topSpacer} />
        <Grid container style={{ marginTop: 20, justifyContent: 'center' }}>
          <form className={classes.form}>
            <Card className={classes.card}>
              <CardHeader
                title="Create password"
                style={{ color: "#002D55", marginBottom: 0 }}
                variant="h4"
              />
              <Typography
                style={{ marginTop: 5, marginBottom: 5, marginLeft: 17 }}
                color="textSecondary"
                gutterBottom
                variant="h7">
                Please create a new password for your patient profile.
                      </Typography>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={12} xs={12}  >
                    <TextField
                      className={classes.textField}
                      fullWidth
                      label="Create new password"
                      name="NewPassword"
                      required
                      variant="outlined"
                      type="password"
                      onChange={event => {
                        setConfirmPassword1(event.currentTarget.value)
                      }}
                      value={confirmPassword1}
                    />
                  </Grid>
                  <Grid item md={12} xs={12} >
                    <TextField
                      className={classes.textField}
                      fullWidth
                      label="Confirm new password"
                      name="ConfirmPassword"
                      required
                      variant="outlined"
                      type="password"
                      style={{ marginBottom: 25 }}
                      onChange={event => {
                        setConfirmPassword2(event.currentTarget.value)
                      }}
                      value={confirmPassword2}
                    />
                  </Grid>
                </Grid>
                <Button
                  className={classes.Button}
                  variant="contained"
                  onClick={handleSetPassword}
                >
                  Save password
                        </Button>
              </CardContent>

            </Card>
          </form>
        </Grid>
        <Grid item xs={12} className={classes.footerSpacer} />
        <Grid item xs={12} container justifyContent="center">
          <Footer />
        </Grid>
      </Grid>
    );
  } else {
    return <p>Loading</p>
  }
};

export default Verify_user;